import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
//import createEncryptor from 'redux-persist-transform-encrypt'

import rootReducer from "./reducers.js";
import config from "../config/index.js";
import storage from "redux-persist-indexeddb-storage";

// const encryptor = createEncryptor({
//   secretKey: config.app.security.routeKey,
//   onError: function(error) {
//     // Handle the error.
//   }
// })

const transforms = [];

if (process.env.MODE === "PROD") {
    //transforms.push(encryptor)
}

const persistConfig = {
    key: "Baziigram",
    storage: storage("BaziigramDB"),
    stateReconciler: autoMergeLevel2,
    debug: false,
    transforms,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default () => {
    let store = createStore(persistedReducer);

    /** Register SAGAs */

    let persistor = persistStore(store);
    return { store, persistor };
};
